export const HOME_GET_STARTED = "home/HOME_GET_STARTED";
export const HOME_GET_SUCCESS = "home/HOME_GET_SUCCESS";
export const HOME_GET_FAILED = "home/HOME_GET_FAILED";